import {ProductPageApp} from '../../../productPage/components/ProductPageApp/ProductPageApp';
import {withGlobalPropsProvider} from '../../../productPage/providers/globalPropsProvider';
import {withAllStyles} from '../../../productPage/providers/allStyleProvider';
import {withStylesParams} from '../../../productPage/providers/stylesParamsProvider';
import stylesParams from '../stylesParams';

const WidgetWithAllStyles = withAllStyles(withStylesParams(ProductPageApp, stylesParams));
const ProductPageWidget = withGlobalPropsProvider(WidgetWithAllStyles);

export default ProductPageWidget;
